<script>
import FooterCopyright from './FooterCopyright.vue';
import FeatherIcon from '../reusable/FeatherIcon.vue';
import { socialLinks } from '../../data/socialLinks';

export default {
	components: { FeatherIcon, FooterCopyright },
	data() {
		return {
			socials: socialLinks,
		};
	},
};
</script>

<template>
	<div class="container mx-auto">
		<div
			class="pt-20 sm:pt-30 pb-8 mt-20 border-t-2 border-primary-light dark:border-secondary-dark"
		>
			<!-- Footer social links -->
			<div
				class="flex flex-col justify-center items-center mb-12 sm:mb-20"
			>
				<p
					class="font-general-semibold text-3xl sm:text-4xl font-semibold text-primary-dark dark:text-primary-light mb-5"
				>
					Learn more about me 👇🏼
				</p>
				<ul class="flex gap-4 sm:gap-8">
					<li v-for="social in socials" :key="social.id">
						<a
							:href="social.url"
							:target="social.url.startsWith('mailto:') ? undefined : '_blank'"
							:rel="social.url.startsWith('mailto:') ? undefined : 'noopener noreferrer'"
							:aria-label="social.name"
							class="inline-flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 rounded-lg text-gray-400 hover:text-indigo-500 dark:hover:text-indigo-400 bg-gray-50 dark:bg-ternary-dark hover:bg-gray-100 shadow-sm duration-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:focus:ring-offset-ternary-dark"
						>
							<FeatherIcon
								:name="social.icon"
								class="w-5 h-5 sm:w-8 sm:h-8 shrink-0"
							/>
						</a>
					</li>
				</ul>
			</div>

			<!-- Footer copyright -->
			<FooterCopyright />
		</div>
	</div>
</template>

<style scoped></style>
